import React from 'react';

import { Cell, Container, Grid } from '@zeiss/ods-components-react';

import { IScore } from '../../../types';
import {
  StyledScoreHeading,
  StyledScoreQRCode,
  StyledScoreSlide,
} from '../styled';
import { Headline, SoundPlayer, Text } from '../../../components';
import { timing } from '../../../timing';
import { useSlider } from '../../../hooks';

type ScoreSlideProps = { id: string; index: number; score: IScore };

const ScoreSlide = (props: ScoreSlideProps) => {
  const { score, id, index } = props;
  const isQrcodeVisible = false;
  const [ref, setRef] = React.useState<HTMLAudioElement | null>(null);

  const { activeSlide } = useSlider();

  React.useEffect(() => {
    if (ref && activeSlide !== undefined) {
      if (!ref.paused && activeSlide !== index) {
        ref.pause();
        ref.currentTime = 0;
      }
    }
  }, [activeSlide, ref]);

  const times = timing.find((item) => item.id === score.id);

  // render audio player only for an active, next and prev slides
  const show =
    activeSlide === index ||
    activeSlide + 1 === index ||
    activeSlide - 1 === index;

  // TODO: remove this when needed improved rendering
  // show = true;

  return (
    <StyledScoreSlide id={id}>
      <Grid>
        <Container.FullBleed>
          <Cell.Basic colStarts={2} colSpan={3}>
            <StyledScoreHeading>
              <Headline headline={score['score-title']} />
              <Text size="l">{score['score-text']}</Text>
              {isQrcodeVisible && (
                <StyledScoreQRCode>
                  <img
                    src="./images/qrcodes/qrcode-placeholder.png"
                    alt={score['score-title']}
                  />
                  <div>
                    <Text>May the sound be with you</Text>
                    <Text>
                      Take this musical experience with you on your smartphone.
                    </Text>
                  </div>
                </StyledScoreQRCode>
              )}
            </StyledScoreHeading>
          </Cell.Basic>
          <Cell.Basic colStarts={6} colSpan={6}>
            {show && (
              <SoundPlayer
                ref={(r) => setRef(r)}
                times={times}
                imgUrl={`./images/musical-scores/${score.image}`}
                audioUrl={`./audios/musical-scores/${score.audio}`}
              />
            )}
          </Cell.Basic>
        </Container.FullBleed>
      </Grid>
    </StyledScoreSlide>
  );
};

export default ScoreSlide;
